import React, { useEffect, useState } from "react";
import InsightTable from "../InsightTable";
import { transformResultsToTableData } from "../../../../services/commonService";

function PatentLicensingCollaborations({ patentLicensingAndCollaborations }) {
  const [tabData, setTabData] = useState([]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    { type: "conversation", title: "Conversation", onClick: () => {} },
    { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  // const dummyData = [
  //   {
  //     competitor: "a",
  //     licensing_strategy: "b",
  //     r_and_d_collaborations: "c",
  //     open_innovation: "d",
  //     licensing_strategy_positive_insight: "b",
  //     licensing_strategy_negative_insight: "b",
  //     licensing_strategy_recent_development: "b",
  //     r_and_d_collaborations_positive_insight: "c",
  //     r_and_d_collaborations_negative_insight: "c",
  //     r_and_d_collaborations_recent_development: "c",
  //     open_innovation_positive_insight: "d",
  //     open_innovation_negative_insight: "d",
  //     open_innovation_recent_development: "d",
  //   },
  //   {
  //     competitor: "a",
  //     licensing_strategy: "b",
  //     r_and_d_collaborations: "c",
  //     open_innovation: "d",
  //     licensing_strategy_positive_insight: "b",
  //     licensing_strategy_negative_insight: "b",
  //     licensing_strategy_recent_development: "b",
  //     r_and_d_collaborations_positive_insight: "c",
  //     r_and_d_collaborations_negative_insight: "c",
  //     r_and_d_collaborations_recent_development: "c",
  //     open_innovation_positive_insight: "d",
  //     open_innovation_negative_insight: "d",
  //     open_innovation_recent_development: "d",
  //   },
  //   {
  //     competitor: "a",
  //     licensing_strategy: "b",
  //     r_and_d_collaborations: "c",
  //     open_innovation: "d",
  //     licensing_strategy_positive_insight: "b",
  //     licensing_strategy_negative_insight: "b",
  //     licensing_strategy_recent_development: "b",
  //     r_and_d_collaborations_positive_insight: "c",
  //     r_and_d_collaborations_negative_insight: "c",
  //     r_and_d_collaborations_recent_development: "c",
  //     open_innovation_positive_insight: "d",
  //     open_innovation_negative_insight: "d",
  //     open_innovation_recent_development: "d",
  //   },
  // ];

  useEffect(() => {
    const tableData = transformResultsToTableData(
      patentLicensingAndCollaborations
    );
    setTabData(tableData);
  }, [patentLicensingAndCollaborations]);

  const tableColumns = [
    // { key: "competitor", label: "Competitor" },
    { key: "licensing_strategy", label: "Licensing Strategy" },
    { key: "rd_collaborations", label: "R&D Collaborations" },
    { key: "open_innovation", label: "Open Innovation" },
  ];

  return (
    <InsightTable
      title="Patent Licensing & Collaborations"
      subtitle="Benchmarking innovation partnerships, licensing models, and collaborative research efforts to understand each company's strategy for scaling innovation."
      data={tabData}
      metrics={tableColumns}
      rowIdentifier="competitor"
      actions={actions}
    />
  );
}

export default PatentLicensingCollaborations;
